import React from "react";
import Icon from "../ui/Icon";

export default function NetworkingInfoModal({ open, participant, onClose }) {
  if (!open || !participant) return null;

  const roleRaw = String(participant.networkingRole || "").trim();
  const intentRaw = String(participant.networkingIntent || "").trim();

  const roleLabel = roleRaw || "Not set";
  const intentLabel = intentRaw || "No intent provided";

  return (
    <div
      className="jt-modalOverlay"
      role="dialog"
      aria-modal="true"
      onMouseDown={onClose}
    >
      <div className="jt-sheet" onMouseDown={(e) => e.stopPropagation()}>
        <div className="jt-sheetHead">
          <div className="jt-sheetTitle">Networking Details</div>
          <button
            className="jt-sheetClose"
            onClick={onClose}
            aria-label="Close"
          >
            <Icon name="close" />
          </button>
        </div>

        <div className="jt-sheetBody">
          <div style={{ fontWeight: 700, marginBottom: 10 }}>
            {participant?.name || "Participant"}
          </div>

          <div style={{ marginBottom: 8 }}>
            <strong>Role:</strong> {roleLabel}
          </div>

          <div>
            <strong>Intent:</strong> {intentLabel}
          </div>
        </div>
      </div>
    </div>
  );
}
